<ng-template #modalDocumentos let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h2>{{this.evento.accion}} - {{this.nombre}}</h2>
    <button type="button" class="close" aria-label="Close" (click)="c('Close click'); emit();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card">
      <div class="card-content">
        <div class="card-body">
          <div class="row">
            <div class="col-md-5">
              <form class="form-bordered" [formGroup]="adjunto" (submit)="saveOrUpdateRecord()">

                <div class="row" style="justify-content: flex-end; margin-bottom: 2px; margin-top: -20px;"
                     *ngIf="isGranted()">
                  <button type="submit" class="btn btn-success  align-self-end" style="margin-right: 1px;"
                          [disabled]="adjunto.invalid || this.guardado"><i class="ft-save mr-1"></i>Guardar
                  </button>

                  <button class="btn btn-warning align-self-end mr-2"
                          title="Reiniciar Formulario" type="button"
                          (click)="initForm();">
                    <i class="ft-refresh-ccw"></i>
                  </button>
                </div>

                <div *ngIf="procesando">
                  <img src='assets/img/gifcargando.gif' style="width: 60px; display: block; margin:auto;">
                  <p style="text-align: center; background: #f88626; color:#ffffff; padding: 5px; border-radius: 5px;">
                    Procesando Archivo</p>
                </div>
                <div class="form-group row">
                  <label class="col-md-12 label-control">Tipo de Documento <small
                    *ngIf="validateField('idtipadj','required')" class="text-danger">*</small></label>
                  <div class="col-md-12">
                    <div class="position-relative has-icon-left">
                      <select class="form-control" formControlName="idtipadj">
                        <option value="" selected>Seleccione</option>
                        <option *ngFor="let gltipadj of listGltipadj"
                                [value]="gltipadj.identificador">{{gltipadj.descripcion}}</option>
                      </select>
                      <div class="form-control-position">
                        <i class="ft-book"></i>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="form-group row">
                  <div class="col-md-12 col-12">
                    <input type="file" accept="application/pdf,text/xml" (change)="selectFiles($event)" class="form-control"
                           formControlName="archivo"/>
                  </div>
                </div>


                <!-- Comentarios -->

                <div class="form-group row"
                     *ngIf="this.evento.comentarios!=undefined && this.evento.comentarios == true">
                  <label class="col-md-12 label-control">Comentarios</label>
                  <div class="col-md-12">
                    <div class="position-relative has-icon-left">
                  <textarea class="form-control" placeholder="Escribir aquí..." formControlName="comentarios"
                            oninput="this.value = this.value.toUpperCase()" style="height: 80px;"></textarea>
                      <div class="form-control-position">
                        <i class="ft-chevron-right"></i>
                      </div>
                    </div>

                    <small *ngIf="validateField('comentarios','maxlength')" class="text-danger">Máximo 255
                      caracteres</small>

                  </div>
                </div>


              </form>
            </div>


            <div class="col-md-7" style="margin-top: -23px;">
              <app-tabla (emitter)="responseEmitter($event)" [parametrosTabla]="parametrosTabla"></app-tabla>
            </div>

          </div>


        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-info" (click)="c('Close click'); emit();">Cerrar</button>
  </div>
</ng-template>
